import React from 'react';
import ScoreBackground from '../../assets/img/score-background.svg';

class Score extends React.Component {
  state = {
    degree: 0
  };

  componentDidMount() {
    const { score, max = 5 } = this.props;
    const degree = `${(score * 180) / max}deg`;
    setTimeout(() => this.setState({ degree }), 2000);
  }

  render() {
    const { degree } = this.state;
    return (
      <div className="score-container">
        <img src={ScoreBackground} alt="score" />
        <div style={{ transform: `rotateZ(${degree})` }} className="score-pointer" />
      </div>
    );
  }
}

export default Score;
